export default __webpack_public_path__ + "static/media/3.9d03a4d1.jpg";